module.exports = __webpack_public_path__ + "public/Icons/fb.png?ebabb22e";